import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as StopDestinationActions from '../actions/stop-destination.actions';
import * as DestinationsActions from '../actions/destinations.actions';
import {DestinationsService} from '../../../services/api/destinations/destinations.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Destination} from '../../../services/api/destinations/destination.model';


@Injectable()
export class StopDestinationEffects {

  // noinspection JSUnusedGlobalSymbols
  stopDestination$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StopDestinationActions.stopDestination),
      concatMap((payload) =>
        this.destinationsService.stopDestination(payload.id).pipe(
          map((data: Destination) => StopDestinationActions.stopDestinationSuccess({data})),
          catchError((error: any) => of(StopDestinationActions.stopDestinationFailure({error}))))
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  startDestinationSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StopDestinationActions.stopDestinationSuccess),
      tap(() => this.snackBar.open('Destination stopped successfully', 'Success', {duration: 3000})),
      map(() => DestinationsActions.loadDestinations())
    );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly snackBar: MatSnackBar,
    private readonly destinationsService: DestinationsService
  ) {
  }

}
